module.exports = __webpack_public_path__ + "img/right5.288b318f.png";